export default {
    DEFAULT: 'USD',
    DEFAULT_SYMBOL: '$',
    ITEMS: [
        {
            id: 1,
            value: 'CAD',
            name: 'CAD',
        },
        {
            id: 2,
            value: 'USD',
            name: 'USD',
        },
        {
            id: 3,
            value: 'EUR',
            name: 'EUR',
        },
        {
            id: 4,
            value: 'GBP',
            name: 'GBP',
        },
    ],
};
